import { mountApplication, type ApplicationMountOptions } from '../app/mount.tsx';
import { resolveLocale } from '../localization/locale.ts';
import { createBrowserLocaleUrlState } from '../localization/url-state.ts';
import '../styles/fonts.css';
import '../styles/app-shell.css';

export type BootstrapEngine = 'fake' | 'maplibre';

export interface BootstrapOptions {
  readonly engine: BootstrapEngine;
  readonly engineVersion?: string;
  readonly application?: ApplicationMountOptions;
}

export function bootstrap(options: BootstrapOptions): void {
  const applicationRoot = document.querySelector<HTMLElement>('#app');
  if (applicationRoot === null) {
    throw new Error('application root is missing');
  }

  applicationRoot.dataset['engine'] = options.engine;
  applicationRoot.dataset['status'] = 'bootstrapped';
  if (options.engineVersion !== undefined) {
    applicationRoot.dataset['engineVersion'] = options.engineVersion;
  }

  const locale = resolveLocale({
    search: window.location.search,
    browserLanguages: navigator.languages,
  });
  mountApplication(applicationRoot, {
    ...options.application,
    locale,
    localeUrlState: options.application?.localeUrlState ?? createBrowserLocaleUrlState(window),
  });
}
